/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IndiceReajusteDsDocumentacaoAliases {
  FETCH_DS_DOCUMENTACAO = 'fetch-ds-documentacao',
  HPMS_INDICE_REAJUSTE_DS_DOCUMENTACAO_0 = 'hpms-indice-reajuste-ds-documentacao-0',
  LAYOUT_INDICE_REAJUSTE_DS_DOCUMENTACAO = 'layout-indice-reajuste-ds-documentacao',
  PANEL_0 = 'panel-0',
}
export { IndiceReajusteDsDocumentacaoAliases };
